import i18n from 'modules/core/lib/i18n'

const WORKING_HOURS_FREQUENCY_TEXTS: Record<string, () => string> = {
  year: () => i18n.t('common.year'),
  month: () => i18n.t('common.month'),
  week: () => i18n.t('common.week.one'),
  day: () => i18n.t('common.day.one'),
}

export const workingHoursFrequency = (frequency: string) => {
  return WORKING_HOURS_FREQUENCY_TEXTS[frequency]?.() ?? frequency
}
